module.exports = "https://r.nearpod.com/assets/media/image/folder-3481742b8c7a92c496860588a51ed2fd.svg";